import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    routes: [
        // {
        //   path: '/',
        //   name: 'dashboard',
        //   component: require('@/views/dashboard').default
        // },
        {
            path: '/login',
            name: 'login',
            component: require('@/views/login').default
        },
        {
            path: '*',
            redirect: '/'
        },
        {
            path: "/",
            name: "index",
            component: () =>
                import ("@/views/index.vue"),
            children: [{
                    path: '/',
                    redirect: '/dashboard',
                    component: () =>
                        import ("@/views/dashboard")
                },
                {
                    path: '/dashboard',
                    name: 'dashboard',
                    component: () =>
                        import ("@/views/dashboard")
                },
                {
                    path: '/dashboard/messageDetail',
                    name: 'messageDetail',
                    component: () =>
                        import ("@/views/dashboard/messageDetail.vue")
                },
                {
                    path: '/dashboard/messageList',
                    name: 'messageList',
                    component: () =>
                        import ("@/views/dashboard/messageList.vue")
                },
                {
                    path: '/dashboard/doBook',
                    name: 'doBook',
                    component: () =>
                        import ("@/views/dashboard/doBook.vue")
                },

                {
                    path: '/classCenter',
                    name: 'classCenter',
                    component: () =>
                        import ("@/views/classCenter")
                },
                {
                    path: '/classCenter/classCenterDetail',
                    name: 'classCenterDetail',
                    component: () =>
                        import ("@/views/classCenter/classCenterDetail.vue")
                },

                {

                    path: '/classhub',
                    name: 'classhub',
                    component: () =>
                        import ("@/views/classCenter/index2.vue")
                },
                {
                    path: '/classhub/classCenterDetail',
                    name: 'classCenterDetail2',
                    component: () =>
                        import ("@/views/classCenter/classCenterDetail2.vue")
                },







                {
                    path: '/helpCenter',
                    name: 'helpCenter',
                    component: () =>
                        import ("@/views/helpCenter.vue")
                },




                {
                    path: '/product',
                    name: 'product',
                    component: () =>
                        import ("@/views/product")
                },
                {
                    path: '/product/productChoose',
                    name: 'productChoose',
                    component: () =>
                        import ("@/views/product/productChoose.vue")
                },
                {
                    path: '/product/productPerson',
                    name: 'productPerson',
                    component: () =>
                        import ("@/views/product/productPerson.vue")
                },
                {
                    path: '/product/productTeam',
                    name: 'productTeam',
                    component: () =>
                        import ("@/views/product/productTeam.vue")
                },
                {
                    path: '/product/productCreatTeam',
                    name: 'productCreatTeam',
                    component: () =>
                        import ("@/views/product/productCreatTeam.vue")
                },
                {
                    path: '/product/productDetail',
                    name: 'productDetail',
                    component: () =>
                        import ("@/views/product/productDetail.vue")
                },
                {
                    path: '/product/productStep1',
                    name: 'productStep1',
                    component: () =>
                        import ("@/views/product/productStep1.vue")
                },
                {
                    path: '/product/productStep2',
                    name: 'productStep2',
                    component: () =>
                        import ("@/views/product/productStep2.vue")
                },
                // copy
                {
                    path: '/product/productStep2copy',
                    name: 'productStep2',
                    component: () =>
                        import ("@/views/product/productStep2copy.vue")
                },
                {
                    path: '/product/productStep3',
                    name: 'productStep3',
                    component: () =>
                        import ("@/views/product/productStep3.vue")
                },
                {
                    path: '/product/productStep4',
                    name: 'productStep4',
                    component: () =>
                        import ("@/views/product/productStep4.vue")
                },
                {
                    path: '/product/productStep5',
                    name: 'productStep5',
                    component: () =>
                        import ("@/views/product/productStep5.vue")
                },
                {
                    path: '/product/productStep6',
                    name: 'productStep6',
                    component: () =>
                        import ("@/views/product/productStep6.vue")
                },
                {
                    path: '/product/productStep7',
                    name: 'productStep7',
                    component: () =>
                        import ("@/views/product/productStep7.vue")
                },
                {
                    path: '/product/productStep8',
                    name: 'productStep8',
                    component: () =>
                        import ("@/views/product/productStep8.vue")
                },














                {
                    path: '/shop',
                    name: 'shop',
                    component: () =>
                        import ("@/views/shop")
                },
                {
                    path: '/shop/shopDetail',
                    name: 'shopDetail',
                    component: () =>
                        import ("@/views/shop/shopDetail.vue")
                },

                {
                    path: '/userCenter',
                    name: 'userCenter',
                    component: () =>
                        import ("@/views/userCenter")
                },
                {
                    path: '/userCenter/userCenterUpdate',
                    name: 'userCenterUpdate',
                    component: () =>
                        import ("@/views/userCenter/userCenterUpdate.vue")
                },

            ]
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js